import React, { useEffect, useState } from "react";
import QRGenerator from "../../../components/QRGenerator";

interface QRCodeEntry {
    id: string;
    eventID: number;
    validFrom: string;
    validTo: string;
    type: string;
    title: string;
    company: string;
    contactPerson: string;
    email: string;
    used: boolean;
    qrCode: string;
}

const QRCodeList: React.FC = () => {
    const [qrCodes, setQrCodes] = useState<QRCodeEntry[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        fetchQRCodes();
    }, []);

    const fetchQRCodes = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/qr/list`);
            if (!response.ok) throw new Error("Kunne ikke hente QR-koder");

            const data = await response.json();
            setQrCodes(data);
        } catch (err) {
            setError("Fejl ved hentning af QR-koder");
        } finally {
            setLoading(false);
        }
    };

    const deleteQRCode = async (id: string) => {
        if (!window.confirm("Er du sikker på, at du vil slette denne QR-kode?")) return;

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/qr/delete/${id}`, {
                method: "DELETE",
            });

            if (!response.ok) throw new Error("Fejl ved sletning");

            setQrCodes(qrCodes.filter(qr => qr.id !== id));
        } catch (err) {
            alert("Kunne ikke slette QR-kode. Prøv igen senere.");
        }
    };

    return (
        <div className="flex flex-col items-center p-6">
            <h1 className="text-3xl font-bold mb-6 text-gray-800">QR Kode Oversigt</h1>

            {loading && <p className="text-gray-500">Indlæser QR-koder...</p>}
            {error && <p className="text-red-500">{error}</p>}

            <div className="overflow-x-auto w-full max-w-6xl">
                <table className="w-full border-collapse shadow-lg rounded-lg overflow-hidden">
                    <thead className="bg-blue-500 text-white">
                        <tr>
                            <th className="p-3 text-left">Event ID</th>
                            <th className="p-3 text-left">Titel</th>
                            <th className="p-3 text-left">Firma</th>
                            <th className="p-3 text-left">Gyldig fra</th>
                            <th className="p-3 text-left">Gyldig til</th>
                            <th className="p-3 text-left">Type</th>
                            <th className="p-3 text-left">Brugt</th>
                            <th className="p-3 text-center">QR Kode</th>
                            <th className="p-3 text-center">Handling</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white">
                        {qrCodes.map((qr) => (
                            <tr key={qr.id} className="border-b hover:bg-gray-100 transition">
                                <td className="p-3">{qr.eventID}</td>
                                <td className="p-3">{qr.title}</td>
                                <td className="p-3">{qr.company}</td>
                                <td className="p-3">{qr.validFrom}</td>
                                <td className="p-3">{qr.validTo}</td>
                                <td className="p-3">{qr.type}</td>
                                <td className={`p-3 font-semibold ${qr.used ? "text-red-500" : "text-green-500"}`}>
                                    {qr.used ? "Ja" : "Nej"}
                                </td>
                                <td className="p-3 text-center">
                                    {/* 🚀 Kun vis QR-koden, hvis den findes */}
                                    {qr.qrCode ? (
                                        <QRGenerator value={qr.qrCode} size={100} />
                                    ) : (
                                            <span className="text-gray-500">{qr.qrCode}</span>
                                    )}
                                </td>
                                <td className="p-3 text-center">
                                    <button
                                        className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded transition"
                                        onClick={() => deleteQRCode(qr.id)}
                                    >
                                        Slet
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default QRCodeList;
